import React, { useEffect, useState } from "react";
import Pagination from "../../../utils/Paginate";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
// import { useAuth } from "../Auth/Auth";
import { apiHeader } from "../../../utils/apiHeader";
import axios from "axios";
import TableLoader from "../../../Skeleton/TableLoader";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");

const ListContentAssociationTypes = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
//   const { token, userMetadata } = useAuth();
	const token = globalConfig.hardcoded_header;
  const [search, setSearch] = useState("");
  const [state, setState] = useState({
    contentAssociationTypes: [],
    filteredContentAssociationTypes: [],
  });

  useEffect(() => {
    handleOnLoad();
  }, []);

  useEffect(() => {
    handleSearch(search);
  }, [search]);
  useEffect(() => {
    console.log(state);
  }, [state]);
  const handleOnLoad = () => {
    setLoading(true);
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-association-types`,
        apiHeader(token)
      )
      .then((res) => {
        const contentAssociationTypes = res.data;
        console.log(contentAssociationTypes);
        setState({
          ...state,
          contentAssociationTypes: contentAssociationTypes,
          filteredContentAssociationTypes: contentAssociationTypes,
        });
        console.log(res.data[0]);
        setLoading(false);
      })
      .catch((x) => {
      });
  };
  function onDelete(event) {
    let deleteID = event.target.id;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/content-association-types/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        setState({
          ...state,
          contentAssociationTypes: [],
          filteredContentAssociationTypes: [],
        });
        handleOnLoad();
      })
      .catch((err) => console.log("Err delete:" + err));

    setState({
      ...state,
      contentAssociationTypes: [],
      filteredContentAssociationTypes: [],
    });
    handleOnLoad();
    // this.props.history.push("/list-content-descriptors");
  }

  const handleSearch = (search) => {
    let URL = `${globalConfig.apiDatahubUrl}/content-association-types?filter[limit]=50`;
    URL += `&filter[where][or][0][contentAssociationTypeName][regexp]=/(${search})/i`;
    axios.get(URL, apiHeader(token)).then((res) => {
      const contentAssociationTypes = res.data;
      console.log(contentAssociationTypes);
      setState({
        ...state,
        filteredContentAssociationTypes: contentAssociationTypes,
      });
      console.log(res.data[0]);
    })
    .catch((x) => {
    });
  };
  const indexOfLastData = currentPage * globalConfig.dataPerPage;
  const indexOfFirstData = indexOfLastData - globalConfig.dataPerPage;
  const currentData = state.filteredContentAssociationTypes.slice(
    indexOfFirstData,
    indexOfLastData
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  //handler for page
  const handlePage = (page) => {
    setCurrentPage(page);
  };
  return (
    <form>
    	<div style={{ display: "flex", justifyContent: "space-between" }}>
    		<h4>Content Association Types</h4>
		<div style={{display:"flex",justifyContent:"flex-end"}}>
        <Link to="/breeze/create-content-association-type">
          <Button
            variant="contained"
            color="success"
          >
            Create
          </Button>
        </Link>&nbsp;
        <Link to="/breeze/list-content-associations">
          <Button
            variant="contained"
            color="warning"
          >
            Associations
          </Button>
        </Link>&nbsp;
		<Link to="/breeze">
			<Button variant="contained">Go Back</Button>
		</Link>
		</div>
		</div>
		<hr/>

      <div className="container-fluid">
        <div className="form-group">
          <input
            className="form-control"
            type="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            id="exampleFormControlInput1"
            placeholder="Search"
          />
        </div>
        <div className="form-group row">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Name</th>
                <th scope="col">Description</th>
                <th scope="col">App</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {!loading ? (
                currentData.map(
                  ({
                    contentAssociationTypeId,
                    contentAssociationTypeName,
                    contentAssociationTypeDescr,
                    contentAssociationTypeAppId,
                  }) => {
                    return (
                      <tr>
                        <td>
                          <Link
                            to={{
                              pathname: "/manage-content-association-types",
                              search: `?id=${contentAssociationTypeId}`,
                            }}
                          >
                            {contentAssociationTypeId}
                          </Link>
                        </td>
                        <td>
                          <Link
 
                            to={{
                              pathname: "/manage-content-association-types",
                              search: `?id=${contentAssociationTypeId}`,
                            }}
                          >
                            {contentAssociationTypeName}
                          </Link>{" "}
                        </td>
                        <td>
                          <Link
                            to={{
                              pathname: "/manage-content-association-types",
                              search: `?id=${contentAssociationTypeId}`,
                            }}
                          >
                            {" "}
                            {contentAssociationTypeDescr}
                          </Link>
                        </td>
                        <td>
                          <Link
                           
                            to={{
                              pathname: "/manage-content-association-types",
                              search: `?id=${contentAssociationTypeId}`,
                            }}
                          >
                            {" "}
                            {contentAssociationTypeAppId}
                          </Link>
                        </td>
                        <td>
                          <Link
                            className="btn btn-success"
                            to={{
                              pathname: "/manage-content-association-types",
                              search: `?id=${contentAssociationTypeId}`,
                            }}
                          >
                            Edit{" "}
                          </Link>
                          &nbsp;
                          <button
                            onClick={onDelete}
                            id={contentAssociationTypeId}
                            className="btn btn-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    );
                  }
                )
              ) : (
                <tr>
                  {new Array(5).fill(0).map((_, index) => (
                    <TableLoader key={index} theme={"dark"} />
                  ))}
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          dataPerPage={globalConfig.dataPerPage}
          totaldata={state.filteredContentAssociationTypes.length}
          paginate={paginate}
          currentPage={currentPage}
          onChange={handlePage}
        />
      </div>
    </form>
  );
};

export default ListContentAssociationTypes;
